import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';

export const getSearchGroupTemplatesState = createSelector(getDragonflyState, (state) => state?.searchGroupTemplates);

export const getPanelExpandedValue = createSelector(getSearchGroupTemplatesState, (state) => state?.panelExpanded);

export const getCode = createSelector(getSearchGroupTemplatesState, (state) => state?.code);

export const getRemarks = createSelector(getSearchGroupTemplatesState, (state) => state?.remarks);

export const getInactive = createSelector(getSearchGroupTemplatesState, (state) => state?.inactive);

export const getUpdateGroupTemplateRoleExist = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('bookcoupongrouptemplate.update') ? true : false,
);

export const getCreateNewGroupTemplateBtnEnabled = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('bookcoupongrouptemplate.create') ? true : false,
);
